('use strict');
let watermark = {
    id: '1.23452384164.123412415',
    fillStyle: 'rgba(200, 200, 200, 0.40)', // 绘画字体颜色及渐变效果
    textAlign: 'left', // 文本内容对齐方式
    textBaseline: 'Middle', // 使用的文本基线
    fontSize: '14px', // 字体大小
    textPositonX: 0, // 水印的起始X坐标
    textPositonY: 0, // 水印的起始Y坐标
    rowNum: 3, // 平铺几行水印
    colNum: 2, // 平铺几列水印
    rotate: 0, // 旋转角度
    brFlag: ';', // 换行标识
    brDistance: 30 // 换行间距
};
let setWatermark = str => {
    let id = watermark.id;

    if (document.getElementById(id) !== null) {
        document.body.removeChild(document.getElementById(id));
    }
    //创建一个画布
    let can = document.createElement('canvas');
    //设置画布的长宽
    can.width = document.documentElement.clientWidth / watermark.colNum;
    can.height = document.documentElement.clientHeight / watermark.rowNum;
    let cans = can.getContext('2d');
    cans.translate(can.width / 2, can.height / 2);
    cans.rotate((watermark.rotate * Math.PI) / 180);
    //设置填充绘画的字体
    cans.font = watermark.fontSize + ' Vedana';
    //设置填充绘画的颜色、渐变或者模式
    cans.fillStyle = watermark.fillStyle;
    //设置文本内容的当前对齐方式
    cans.textAlign = watermark.textAlign;
    //设置在绘制文本时使用的当前文本基线
    cans.textBaseline = watermark.textBaseline;
    //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
    var textPositonX = 0 - can.width / 2 + watermark.textPositonX;
    var row = str.split(watermark.brFlag);
    for (var i = 0; i < row.length; i++) {
        cans.fillText(row[i], textPositonX, (watermark.textPositonY + i) * watermark.brDistance);
    }

    let div = document.createElement('div');
    div.id = id;
    div.style.pointerEvents = 'none';
    div.style.top = '0px';
    div.style.left = '0px';
    div.style.position = 'fixed';
    div.style.zIndex = '100000';
    div.style.width = document.documentElement.clientWidth + 'px';
    div.style.height = document.documentElement.clientHeight + 'px';
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
    document.body.appendChild(div);
    return id;
};
// 该方法只允许调用一次
watermark.set = str => {
    let id = setWatermark(str);
    setInterval(() => {
        if (document.getElementById(id) === null) {
            id = setWatermark(str);
        }
    }, 500);
    window.onresize = () => {
        setWatermark(str);
    };
};
watermark.remove = () => {
    let id = watermark.id;
    if (document.getElementById(id) !== null) {
        document.body.removeChild(document.getElementById(id));
    }
};
watermark.setOptions = opts => {
    if (!isJson(JSON.stringify(opts))) return;
    for (let k in opts) {
        watermark[k] = opts[k];
    }
};

function isJson(str) {
    if (typeof str === 'string') {
        try {
            let obj = JSON.parse(str);
            return !!(obj && typeof obj === 'object');
        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
}

export default watermark;
